export default "__VITE_ASSET__19f5bb1c__"